import React, { useState } from "react";
import { toast } from "sonner";
import { Copy, EnvelopeSimple } from "@phosphor-icons/react";
import { btnGhost } from "../ui";

const SUBJECT = "Microsoft 365 access request: OTM Tech AI warranty email drafts";
const body = (mailbox) => `Hi,

Our warranty app (OTM Tech AI) needs permission to save email DRAFTS into the ${mailbox} mailbox. It never sends email. Our warranty team opens each draft in Outlook, checks it and presses Send themselves.

Could you please set this up in Microsoft Entra (entra.microsoft.com):

1. App registrations > New registration
   - Name: OTM Tech AI - Warranty drafts
   - Supported account types: Accounts in this organisational directory only
   - Redirect URI: leave blank
2. API permissions > Add a permission > Microsoft Graph > Application permissions > Mail.ReadWrite > Add permissions, then click "Grant admin consent".
3. Certificates & secrets > New client secret (24 months), and copy the secret Value straight away.
4. Recommended: limit the app to the ${mailbox} mailbox only (Exchange Online Application Access Policy or RBAC for Applications), so it can't open any other mailbox.

Then please send me these three details securely (not in a plain email if possible):
- Directory (tenant) ID
- Application (client) ID
- Client secret value

Thanks!`;

export function ItAdminRequest({ mailbox }) {
  const [to, setTo] = useState("");
  const text = body(mailbox);
  const copy = () => navigator.clipboard.writeText(`Subject: ${SUBJECT}\n\n${text}`).then(() => toast.success("Request copied. Paste it into an email to your IT admin")).catch(() => toast.error("Couldn't copy"));
  const mailto = `mailto:${to.trim()}?${new URLSearchParams({ subject: SUBJECT, body: text }).toString().replace(/\+/g, "%20")}`;
  return (
    <div className="border border-neutral-800 bg-black/30 rounded-xl p-4 space-y-3" data-testid="wi-it-request">
      <div className="text-sm text-neutral-200 font-semibold">Ask your Microsoft 365 admin</div>
      <p className="text-xs text-neutral-400">Only your Office 365 administrator can allow the app into the warranty@ mailbox. This ready-made request tells them exactly what to set up (drafts only, nothing is sent).</p>
      <details className="text-xs text-neutral-400"><summary className="cursor-pointer text-[#73bf44]" data-testid="wi-it-request-toggle">Read the request</summary>
        <pre className="whitespace-pre-wrap font-sans mt-2 bg-black/40 border border-neutral-800 rounded-lg p-3 text-neutral-300" data-testid="wi-it-request-text">{text}</pre></details>
      <input type="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="IT admin's email (optional)" data-testid="wi-it-request-to"
        className="w-full bg-black/50 border border-neutral-800 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#73bf44] transition-colors" />
      <div className="flex flex-wrap gap-2">
        <a href={mailto} className={btnGhost} data-testid="wi-it-request-email-btn"><EnvelopeSimple size={15} /> Email the request</a>
        <button className={btnGhost} onClick={copy} data-testid="wi-it-request-copy-btn"><Copy size={15} /> Copy request</button>
      </div>
      <p className="text-[0.7rem] text-neutral-500">When IT sends back the three details, they're added to the app's secure settings and the waiting emails go into Outlook as drafts.</p>
    </div>
  );
}
